import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./Header";
import Home from "../Dashboard/Home";
import { useAutoLogout } from "../hooks/UseAutoLogout";
import LeftSidebar from "./LeftSidebar";
import Migration from "../migrations/Migration";
import Profile from "../Profile/Profile";
import EditProfile from "../Profile/EditProfile";
import ViewReportsPage from "../migrations/viewReportspage";
import "../../App.css";
// import DBMigrationhomepage from "../DBMigration/DBMigrationhomepage"
import ListOfMigrationTable from "../DBMigration/ListOfMigrationTable";
import Settingsnew from "../Settings/Settingsnew";
import DBMigration from "../DBMigration/DBMigration";
import SourceProfile from "../SourceProfile/SourceProfile";
import WelcomeOverlay from "./WelcomeScreen";

function Dashboard() {
  const location = useLocation();
  const [showWelcomeOverlay, setShowWelcomeOverlay] = useState(false);
  const [activeTab, setActiveTab] = useState("#home");
  const [isCollapsed, setIsCollapsed] = useState(
    JSON.parse(localStorage.getItem("isCollapsed")) ?? true
  );
  // This state is now the single source of truth for the profile object
  const [profile, setProfile] = useState(null);
   // --- START: NEW GITHUB CONFIGURATION STATE ---
  const [githubConfig, setGithubConfig] = useState({
    isConfigured: false,
    details: null,
  });
  const [isGithubConfigLoading, setIsGithubConfigLoading] = useState(true);


  
  // Fetch GitHub configuration once when the dashboard loads
  useEffect(() => {
    const fetchGithubConfig = async () => {
      try {
        const apiBase = process.env.REACT_APP_API_URL_CODE_CONVERSION;
        const accessToken = sessionStorage.getItem("access_token");
        if (!accessToken) return;

        const response = await fetch(`${apiBase}/user_github_details`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          // Check if essential details are present
          if (result && result.username && result.access_token) {
            setGithubConfig({ isConfigured: true, details: result });
          } else {
            setGithubConfig({ isConfigured: false, details: result });
          }
        }
      } catch (error) {
        console.error("Error fetching GitHub config in Dashboard:", error);
        setGithubConfig({ isConfigured: false, details: null });
      } finally {
        setIsGithubConfigLoading(false);
      }
    };

    fetchGithubConfig();
  }, []);

  useEffect(() => {
    const pathToTabMap = {
      "/home": "#home",
      "/migration": "#migjob",
      "/migration/deleted_jobs": "#migjob-deleted",
      "/migration/viewReportspage": "#migjob",
      "/migration/draft_jobs": "#migjob",
      "/profile": "#profile",
      "/edit-profile": "#profile",
      "/dbmigration": "#dbmigration",
      "/listmigration": "#dbmigration-list",
      "/settings": "#settings",
      "/sourceprofiler": "#sourceprofiler",
      "/sourceprofiler/deleted_sources": "#sourceprofiler-deleted",
      "/sourceprofiler/draft_jobs": "#sourceprofiler",
    };

    let newTab = "#home";

    if (pathToTabMap[location.pathname]) {
      newTab = pathToTabMap[location.pathname];
    }
    if (location.pathname === "/settings") {
      setIsCollapsed(false);
      localStorage.setItem("isCollapsed", "false");
    } else if (location.pathname.startsWith("/migration/viewReportspage")) {
      newTab = "#migjob";
    }

    setActiveTab(newTab);
    localStorage.setItem("activeTab", newTab);
  }, [location.pathname]);

  useEffect(() => {
    const userData = sessionStorage.getItem("user_data");
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        if (parsedData.new_user === true) {
          setShowWelcomeOverlay(true);
          parsedData.new_user = false;
          sessionStorage.setItem("user_data", JSON.stringify(parsedData));
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes progress {
        0% { width: 0% }
        100% { width: 100% }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("isCollapsed", JSON.stringify(isCollapsed));
    if (isCollapsed) {
      document.body.classList.add("vertical-collpsed");
    } else {
      document.body.classList.remove("vertical-collpsed");
    }
  }, [isCollapsed]);

  useAutoLogout();

  return (
    <div>
      {showWelcomeOverlay && (
        <WelcomeOverlay onComplete={() => setShowWelcomeOverlay(false)} />
      )}
      <Header
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
        profile={profile} // Pass the central profile state to the header
      />
      <div className="d-flex">
        <LeftSidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <div className="main-content index-bg ms-0 w-100">
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route
              path="/home"
              element={
                <Home
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  profile={profile}
                />
              }
            />
            <Route path="sourceprofiler">
              <Route
                index
                element={
                  <SourceProfile
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                }
              />
              <Route
                path="deleted_sources"
                element={
                  <SourceProfile
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    viewType="deleted"
                  />
                }
              />
               <Route
                path="draft_jobs"
                element={
                  <SourceProfile
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    viewType="draft"
                  />
                }
              />
            </Route>

            <Route
              path="/listmigration"
              element={
                <DBMigration
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              }
            />
            <Route path="migration">
              <Route
                index
                element={
                  <Migration
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    isGithubConfigured={githubConfig.isConfigured}
                  />
                }
              />
              <Route
                path="deleted_jobs"
                element={
                  <Migration
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    viewType="deleted"
                  />
                }
              />
              <Route
                path="draft_jobs"
                element={
                  <Migration
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    viewType="draft"
                  />
                }
              />
              <Route
                path="viewReportspage"
                element={
                  <ViewReportsPage
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                }
              />
            </Route>

            <Route
              path="/profile"
              element={
                <Profile
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setProfile={setProfile} // Pass the setter function
                />
              }
            />
            <Route
              path="/edit-profile"
              element={
                <EditProfile
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  profile={profile} // Pass the central profile state
                />
              }
            />

            <Route
              path="/settings"
              element={
                <Settingsnew
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsCollapsed={setIsCollapsed}
                  // Pass the central profile state and its setter down
                  profile={profile}
                  setProfile={setProfile}
                   githubConfig={githubConfig.details}
                  setGithubConfig={setGithubConfig} // Pass the setter to update state from child
                  isGithubConfigLoading={isGithubConfigLoading}
                />
              }
            />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;